import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const ShortLinkApi = {
    getShortLinks,
    createShortLink,
    updateShortLink,
    deleteShortLink,
    getShortLinkStats,
    renameShortLinkGroup,
}

async function getShortLinks({ headers, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/short-links`, {
        headers: headers,
        params: params,
    })
}

async function createShortLink({ headers, body }) {
    return await authAxios.post(`${MAIN_API_HOST}/v2/public/short-links`, body, {
        headers: headers,
    })
}

async function updateShortLink({ headers, id, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/short-links/${id}`, body, {
        headers: headers,
    })
}

async function deleteShortLink({ headers, id }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/short-links/${id}`, {
        headers: headers,
    })
}

async function getShortLinkStats({ headers, id, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/short-links/${id}/stats`, {
        headers: headers,
        params: params,
    })
}

async function renameShortLinkGroup({ headers, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/short-link-groups`, body, {
        headers: headers,
    })
}
